const ImpressumPage = () => {
  return (
    <div className='container-fluid py-4 overflow-auto'>
      <h1>Impressum</h1>
      <p>
        <strong>Angaben gemäß § 5 TMG</strong>
      </p>
      <p>
        Sengi GmbH <br />
        Rudolf-Breitscheid-Str. 10 <br />
        06110 Halle (Saale)
      </p>
      <p>
        <strong>Vertreten durch:</strong> <br />
        Tobias Strauß
      </p>
      <p>
        <strong>Kontakt:</strong> <br />
        Telefon: 0176 34155774 <br />
        E-Mail: contact(at)sengilabs.ai
      </p>
      <p>
        <strong>Umsatzsteuer-ID:</strong> <br />
        Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE123456789
      </p>
      <p>
        <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong> <br />
        Tobias Strauß <br />
        Rudolf-Breitscheid-Str. 10 <br />
        06110 Halle (Saale)
      </p>
      <p>
        <strong>Haftung für Inhalte</strong> <br />
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Dies gilt insbesondere für Inhalte von Fremdservices.
      </p>
      <p>
        <strong>Haftung für Links</strong> <br />
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
        fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
        der Seiten verantwortlich.
      </p>
      <p>
        <strong>Urheberrecht</strong> <br />
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </p>
    </div>
  );
};

export default ImpressumPage;
